import { ref, readonly } from 'vue';
import { AUTO_COLLAPSE_GAP_THRESHOLD, FLOATING_BAR_COLLAPSE_MARGIN } from '../lib/canvas-constants';

const leftCollapsed = ref(false);
const rightCollapsed = ref(false);
const lastAutoCollapseScaledWidth = ref(0);
const leftManualOverride = ref(false);
const rightManualOverride = ref(false);

export function useFormBuilderSidebars() {
  function toggleLeft() {
    leftCollapsed.value = !leftCollapsed.value;
    leftManualOverride.value = !leftCollapsed.value;
  }

  function toggleRight() {
    rightCollapsed.value = !rightCollapsed.value;
    rightManualOverride.value = !rightCollapsed.value;
  }

  function evaluateAutoCollapse(scaledWidth: number, containerWidth: number) {
    const gap = containerWidth - scaledWidth;
    const shouldCollapse = gap <= AUTO_COLLAPSE_GAP_THRESHOLD;
    const isZoomingFurtherIn = scaledWidth > lastAutoCollapseScaledWidth.value;

    if (shouldCollapse && isZoomingFurtherIn) {
      leftCollapsed.value = true;
      rightCollapsed.value = true;
      lastAutoCollapseScaledWidth.value = scaledWidth;
    }
  }

  function evaluateFloatingBarCollapse(barRect: { left: number; right: number }) {
    if (!leftCollapsed.value && !leftManualOverride.value) {
      const leftSidebar = document.querySelector('[data-testid="element-library-sidebar"]');
      const leftRect = leftSidebar?.getBoundingClientRect();
      if (leftRect && leftRect.width > 0 && barRect.left < leftRect.right + FLOATING_BAR_COLLAPSE_MARGIN) {
        leftCollapsed.value = true;
      }
    }

    if (!rightCollapsed.value && !rightManualOverride.value) {
      const rightSidebar = document.querySelector('[data-testid="property-editor-sidebar"]');
      const rightRect = rightSidebar?.getBoundingClientRect();
      if (rightRect && rightRect.width > 0 && barRect.right > rightRect.left - FLOATING_BAR_COLLAPSE_MARGIN) {
        rightCollapsed.value = true;
      }
    }
  }

  function resetFloatingBarOverrides() {
    leftManualOverride.value = false;
    rightManualOverride.value = false;
  }

  return {
    leftCollapsed: readonly(leftCollapsed),
    rightCollapsed: readonly(rightCollapsed),
    toggleLeft,
    toggleRight,
    evaluateAutoCollapse,
    evaluateFloatingBarCollapse,
    resetFloatingBarOverrides,
  };
}

export function resetSidebarState() {
  leftCollapsed.value = false;
  rightCollapsed.value = false;
  lastAutoCollapseScaledWidth.value = 0;
  leftManualOverride.value = false;
  rightManualOverride.value = false;
}
